import {
    noop,
} from 'lodash'
import BatchActionPopupWrapper from 'app/shared-components/BatchActions/BatchActionPopupWrapper'

// this is dummy popup to check if filters are pulled correctly and
// correct popup is triggered when multiple tabs
const EngagementsDemoBulkUploadPopup = ({
    name,
}: { name: string }) => {
    return (
        <BatchActionPopupWrapper
            onClose={noop}
            renderChildren={({
                data, closePopup,
            }) => {
                return (
                    <div>
                        tab:
                        {name}
                        <br />
                        bulk upload filters:
                        {' '}
                        {JSON.stringify(data)}
                        <br />
                        <button
                            onClick={closePopup}
                            type="button"
                        >
                            close
                        </button>
                    </div>
                )
            }}
        />
    )
}

export default EngagementsDemoBulkUploadPopup
